import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-floor",
  "use": "icon-floor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-floor\"><path d=\"M900.096 436.608l81.408-62.515L512 53.018 42.496 374.068l81.408 62.514-81.408 55.68 81.408 62.516-81.408 55.68L512 970.982l469.504-360.524-81.408-55.68 81.408-62.516-81.408-55.654zM512 734.618l342.912-263.322 36.25 24.806L512 787.252 132.813 496.076l36.275-24.807L512 734.618zm379.187-120.346L512 905.446 132.813 614.272l36.25-24.806L512 852.813 854.912 589.49l36.275 24.781z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol